import { render } from "./ExpensesDonutChart.vue?vue&type=template&id=5dd71d34&ts=true"
import script from "./ExpensesDonutChart.vue?vue&type=script&lang=ts"
export * from "./ExpensesDonutChart.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__